var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4655F6",
    d: "M14.432 5.902a2.6 2.6 0 0 0-.708 1.323a5.06 5.06 0 0 0-5.343 1.15a5.06 5.06 0 0 0-1.148 5.347a2.592 2.592 0 1 0 3.047 3.036a5.06 5.06 0 0 0 5.328-1.157a5.06 5.06 0 0 0 1.157-5.322a2.593 2.593 0 1 0-2.333-4.377m3.028.608a1.714 1.714 0 0 1-1.454 2.905a.3.3 0 0 0-.075 0a.88.88 0 0 0-.913 1.245a3.29 3.29 0 0 1-.658 3.694a3.29 3.29 0 0 1-3.694.657a.88.88 0 0 0-1.113.322a.88.88 0 0 0-.138.541a.3.3 0 0 0 0 .087a1.72 1.72 0 0 1-.478 1.493a1.714 1.714 0 0 1-2.922-1.21a1.7 1.7 0 0 1 .501-1.211c.385-.385.915-.56 1.481-.483q.087.018.175.02a.88.88 0 0 0 .823-.57a.88.88 0 0 0-.023-.684a3.29 3.29 0 0 1 .657-3.694a3.29 3.29 0 0 1 3.694-.657a.875.875 0 0 0 .97-.152a.88.88 0 0 0 .268-.81a1.72 1.72 0 0 1 .478-1.493a1.714 1.714 0 0 1 2.421 0m-6.794 4.15a1.896 1.896 0 1 0 2.682 2.68a1.896 1.896 0 0 0-2.682-2.68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHnt);
export default __webpack_public_path__ + "static/media/hnt.b6fe164d1cdb723a4b3562085a937463.svg";
export { ForwardRef as ReactComponent };